/** Client-side checks and API error text for registration document uploads. */

export const REGISTRATION_UPLOAD_MAX_BYTES = 50 * 1024 * 1024;

export const REGISTRATION_UPLOAD_ACCEPT =
    'image/jpeg,image/png,image/gif,image/webp,application/pdf,.jpg,.jpeg,.png,.gif,.webp,.pdf';

const ALLOWED_MIME = new Set([
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
]);

const ALLOWED_EXT = /\.(jpe?g|png|gif|webp|pdf)$/i;

export function validateRegistrationUploadFile(file) {
    if (!file) {
        return {ok: false, message: 'فایلی انتخاب نشده است.'};
    }
    const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    if (file.size > REGISTRATION_UPLOAD_MAX_BYTES) {
        return {
            ok: false,
            message: `حجم فایل زیاد است (${sizeMb} مگابایت). حداکثر مجاز ۵۰ مگابایت است؛ فایل را فشرده کنید یا با کیفیت پایین‌تر اسکن کنید.`,
        };
    }
    const mimeOk = file.type && ALLOWED_MIME.has(file.type);
    const extOk = ALLOWED_EXT.test(file.name || '');
    if (!mimeOk && !extOk) {
        return {
            ok: false,
            message: 'فرمت فایل پشتیبانی نمی‌شود. فقط JPG، PNG، GIF، WEBP یا PDF مجاز است.',
        };
    }
    return {ok: true, message: ''};
}

export function describeUploadError(err, file, {contextLabel = 'آپلود فایل' } = {}) {
    const status = err?.response?.status;
    const apiMsg = err?.response?.data?.message?.Message
        || err?.response?.data?.message?.['Message:']
        || err?.response?.data?.message
        || err?.message;
    const sizeMb = file ? (file.size / (1024 * 1024)).toFixed(1) : null;

    if (status === 413 || (typeof apiMsg === 'string' && /too large|File too large/i.test(apiMsg))) {
        return `حجم فایل زیاد است${sizeMb ? ` (${sizeMb} مگابایت)` : ''}. حداکثر مجاز ۵۰ مگابایت است؛ فایل را فشرده کنید یا با کیفیت پایین‌تر اسکن کنید.`;
    }
    if (status === 417) {
        return `سرور فایل را نپذیرفت${sizeMb ? ` (حجم ${sizeMb} مگابایت)` : ''}. اگر اسکنر است، به JPG/PNG تبدیل کنید یا حجم را کم کنید.`;
    }
    if (status === 401 || status === 403) {
        return 'نشست منقضی شده؛ دوباره وارد شوید و مجدداً آپلود کنید.';
    }
    if (status === 400) {
        return 'درخواست نامعتبر بود. فرمت فایل را به JPG، PNG یا PDF تغییر دهید و دوباره تلاش کنید.';
    }
    if (!err?.response) {
        return 'ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.';
    }
    if (typeof apiMsg === 'string' && apiMsg && apiMsg !== 'no file id') {
        return `${contextLabel} ناموفق بود: ${apiMsg}`;
    }
    return `${contextLabel} ناموفق بود${status ? ` (کد ${status})` : ''}${sizeMb ? ` — حجم فایل ${sizeMb} مگابایت` : ''}. فرمت JPG/PNG/PDF و حجم زیر ۵۰ مگابایت را امتحان کنید.`;
}
